/* ******************* *
* Geolocate the client *
* ******************** */
function geolocate () {

    $('.geolocate').click(function (e) {
        e.preventDefault();

        var $inputPlaceholder = $('input#' + $(this).data('placeholder'));
        var $inputFor = $('input#' + $(this).data('for'));



        if ('geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition(function (pos) {

                $.get('/Umbraco/Api/GeolocationApi/GetAddress', { lat: pos.coords.latitude, lng: pos.coords.longitude }, function (data) {

                    //$inputPlaceholder.val("Current Location");
                    $inputPlaceholder.val(data);
                    $inputPlaceholder.attr("value", data);
                    $inputFor.val(data);
                    console.log($inputPlaceholder.val() + " id=" + $inputPlaceholder.attr("id"));

                    // Show the clear button
                    $('.btn-clear-absolute').show();

                    // Clear match keyword checkbox
                    $('.keyword-search-checkbox').prop('checked', false);
                });
            });
        } else {
            alert("Sorry, geolocation is not supported by your browser.");
        }
    });

}